import { App } from '@capacitor/app';

export const handleFcmToken = async (
  userId,
  getFcmToken,
  isListenerAttached,
  setIsListenerAttached,
) => {
  if (userId) {
    await getFcmToken(userId);

    if (!isListenerAttached) {
      App.addListener('resume', async () => {
        await getFcmToken(userId);
      });

      setIsListenerAttached(true);
    }
  } else {
    console.error('User ID not found, cannot register for FCM.');
  }
};
